import { Link } from 'reaxl';
import { callToActionAnalytics } from '@/analytics';

export default function HeaderEditorialContent({
    isHomepage,
    isCarousel,
    secondaryLinkUrl,
    superHeroContent,
    superHeroGamData,
    handleReadMoreClick,
}) {
    const {
        bodyText: { internalSecondaryLinkText, header, subHeader },
    } = superHeroContent;

    const fireThirdParty = () => {
        const thirdPartyImpression = superHeroGamData && superHeroGamData['3rd_party_click_tracker'];
        window.location.href = thirdPartyImpression;
    };

    return (
        <div className={`enhanced-super-hero-editorial-container-${isHomepage ? 'hp' : 'slp'}`}>
            <div className={`enhanced-super-hero-editorial-header-${isHomepage ? 'hp' : 'slp'}`}>
                <span dangerouslySetInnerHTML={{ __html: header }} />
            </div>
            <div className={`enhanced-super-hero-editorial-subHeader-${isHomepage ? 'hp' : 'slp'}`}>
                <span>
                    {subHeader}
                </span>

                <div className="display-inline-block padding-horizontal-0">&nbsp; | &nbsp;</div>
                <Link
                    data-cmp="heroAdBarSecondaryCTA"
                    href={secondaryLinkUrl || '#'}
                    onClick={(event) => {
                        if (isCarousel) {
                            handleReadMoreClick(event);
                        } else {
                            callToActionAnalytics.fireHeroAdCTAClick(event, {
                                label: internalSecondaryLinkText,
                                type: 'text-link',
                                cmp: 'oem_rvw_lnk',
                            });
                        }
                        fireThirdParty(event);
                    }}
                >
                    {internalSecondaryLinkText}
                </Link>
            </div>
        </div>
    );
}
